import { Component, OnInit } from '@angular/core';
import { Bodega } from '../../../models/bodega';
import { BodegaService } from '../../../services/bodega.service';
import { SessionService } from '../../../services/session.service';
import { Proforma } from '../../../models/proforma';
import { ProformaDetalle } from '../../../models/proforma-detalle';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { ParametroService } from '../../../services/parametro.service';
import { ProformaService } from '../../../services/proforma.service';
import * as moment from 'moment';
import { Parametro } from '../../../models/parametro';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { ClienteProformaModalComponent } from '../../modals/cliente-proforma-modal/cliente-proforma-modal.component';
import { ProformaModalComponent } from '../../modals/proforma-modal/proforma-modal.component';
import { ProductoService } from '../../../services/producto.service';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';

@Component({
  selector: 'app-proforma-add',
  templateUrl: './proforma-add.component.html',
  styleUrls: ['./proforma-add.component.css'],
  providers: [
    BodegaService,    
    ClienteService,
    BsModalService, 
    ParametroService,
	ProformaService,
	ProductoService,
	ImpuestoPorcentajeService
  ]
})
export class ProformaAddComponent implements OnInit {
	public loading = false;
	public bodegas: Array<Bodega>;
	public proforma: Proforma;
	public proformasDetalle: Array<ProformaDetalle>;
	public param: Parametro;
	public cliente: Cliente;
	public bsModalRef: BsModalRef;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public IVA: number;
	public SECUENCIAL: number;
	public fecha_emision; 
	public fecha_caducidad;
	public isPrinted: boolean;
	public isMail: boolean;
	public proformaIdPrinted: String;
	public cotizacion: string;
	public Mod_Inventario: string;
	public observacion: String;
	public Mod_FactElec: string;
	public fecha_actual;
	public fecha_MesAnt;
	public numero_decimales: number;
	public format_decimal: String;
	public parametros: Array<any>
    public iva_id : number;
	public iva_vigente:boolean;
	public iva_porcentaje : any;


  constructor(
    public ss: SessionService,
    public bodegaService: BodegaService,
    public clienteService: ClienteService,
    public modalService: BsModalService,
    public parametroService: ParametroService,
	public proformaService: ProformaService,
	public utils: UtilsService,
	public productoService: ProductoService,
	public impuestoPorcentajeService: ImpuestoPorcentajeService

  ) {
		this.bodegas = [];
		this.proforma = new Proforma();
		this.proformasDetalle = [];
		this.param = new Parametro();
		this.cliente = new Cliente();
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
		this.IVA = 0;
		this.isMail = false;
		this.isPrinted = false;
		this.SECUENCIAL = 0;
		this.fecha_emision = moment(this.fecha_emision);
		this.fecha_caducidad = moment(this.fecha_caducidad);
		this.fecha_actual = moment(this.fecha_actual);
        this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.Mod_Inventario = this.ss.getData("mod_inventario");
		this.observacion = "";
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.parametros = [];
        this.iva_id = 0;
		this.iva_vigente = false;
		this.iva_porcentaje = 0;
    }

  ngOnInit() {
    let p1 = this.getBodegas();
    let p2 = this.getParametros();
	let p3 = this.getSecuencial();
	let p4 = this.getParamNumeroDecimales();
	let p5 = this.getBodegaBySucursal();
	let p6 = this.getIVA(129);

    this.loading = true;
    Promise.all([p1,p2,p3,p4,p5,p6]).then(
      res=> this.loading = false,
      err=> this.loading = false
    );
  }

	onSubmit() {
		this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar la cotización?").then(
			res => {
				this.setValueEntity();
				this.loading = true;
				this.proformaService.save(this.proforma).subscribe(
					res => {
						this.loading = false;
						this.isPrinted = true;
						this.isMail = true;
						this.proformaIdPrinted = res.id;
						this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente ');
						let bodega_id = this.proforma.bodega_id;
						this.proforma = new Proforma();
						this.proforma.bodega_id = bodega_id;
						this.observacion = "";					
						this.cliente = new Cliente();
						this.proformasDetalle = [];
						this.getBodegas();
						this.getSecuencial();
					},
					err => {
						this.loading = false;
						this.msgSweet.showMessage('error-message',err);
					}
				);
			}
		);
	}

	setValueEntity(){
		this.proforma.secuencial = this.SECUENCIAL;
		this.proforma.cliente_id = this.cliente.id;
		this.proforma.observacion = this.observacion.toString().trim();
		this.proforma.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.proforma.fecha_caducidad = moment(this.fecha_caducidad).format("YYYY-MM-DD");
		this.proforma.usuario_id = this.ss.getData('usuario_id');
		this.proforma.empresa_id = this.ss.getData('empresa_id');
		this.proforma.sucursal_id = this.ss.getData('sucursal_id');    

		this.proformasDetalle.forEach(detalle => {
			detalle.iva = detalle.subtotal * this.IVA;
			detalle.total = detalle.subtotal + detalle.iva;
		});

		this.proforma.detalle = this.proformasDetalle;
	}

	getBodegas() {
		return new Promise((resolve, reject)=>{
			this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
			res => {
				if (!res.data.length) {
				this.bodegas = [];
				} else {
					this.bodegas = res.data;
				}
				resolve();
			},
			err => {
				this.bodegas = [];
				reject(err);
			}
			);
		});
	}

	getBodegaBySucursal(){
        return new Promise((resolve, reject) => {
            if( !this.Mod_Inventario ){
                this.proforma.bodega_id = "1"; // BODEGA POR DEFECTO / SUCURSAL 1
                resolve();
            }else{
                this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                    res => {
                        this.proforma.bodega_id = res.data[0].id;
                        resolve();
                    },
                    err => {
                        this.proforma.bodega_id = "";
                        reject()
                    }
                );
            }
        });
	}
	
	getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.calcularFactura();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					reject(err);
				}
			);

			
		});
	}

	getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	getSecuencial(){
		return new Promise((resolve, reject)=>{
			this.parametroService.getById(8).subscribe(
			res=>{
				this.param = res[0];
				this.SECUENCIAL = parseInt(res.valor);
				resolve();
			},
			err=>{
				this.SECUENCIAL = 0;
				reject(err);
			}
			);
		});
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
	}
	
	get formatDecimal(){
        return this.format_decimal;
    }

	onSearchCliente(event) {
		if( event.keyCode === 13 ){
			if( this.cliente.dni.toString().trim().length == 0 ){
				this.isPrinted = false;
				this.cliente = new Cliente();
				return;
			}else{
				this.loading = true;
				this.clienteService.getByDni(this.cliente.dni).subscribe(
					res => {            
						this.loading = false;
						this.isPrinted = false;
						if (res.length > 0) {
							this.cliente = res[0];              
						}else{
							this.cliente = new Cliente();
							this.openDialogCliente();
						}
					},
					err => {
						this.loading = false;
						this.openDialogCliente();            
					}
				);
			}
		}        
	}

	openDialogCliente() {
		this.isPrinted = false;
		const initialState = {};
		this.bsModalRef = this.modalService.show(ClienteProformaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
		this.bsModalRef.content.sendCliente.take(1).subscribe(cliente => this.cliente = cliente);
	}

	onSearchProducto() {
		if(!this.proforma.bodega_id ){
			this.msgSweet.showMessage('error-message', "Seleccione la bodega");
			return;
		}    
		const initialState = {bodega_id: this.proforma.bodega_id, productoservicio: false, numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
			value.cantidad = 1;
			this.sendObjectProducto(value)
		});
	}

	onSearchConsumible() {

		const initialState = { bodega_id: this.proforma.bodega_id, numero_decimales: this.numero_decimales, es_vendido: 1, tipo_producto_id: '3' };
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {

			// value.precio = 0;
			let incluye_precio = false;
			// this.impuesto_id= value.impuesto_iva_id;
			this.sendObjectProducto(value);
			// if (this.impuesto_id != 0) {
			// 	this.getImpuestoPorcentaje(this.impuesto_id);
			// }
		});


	}

	sendObjectProducto(producto: any) {
		let temp = this.proformasDetalle.find(x => x.producto_id == producto.id);

		//if (!temp) {
		let proforma_detalle = new ProformaDetalle();
		proforma_detalle.cantidad_stock = producto.cantidad_stock;
		//proforma_detalle.cantidad = 1;
		proforma_detalle.cantidad = producto.cantidad;
		// proforma_detalle.es_servicio = producto.es_servicio;
		proforma_detalle.tipo_producto_id = producto.tipo_producto_id;
		proforma_detalle.descripcion = producto.descripcion;
		proforma_detalle.producto = producto.nombre;
		proforma_detalle.codigo = producto.codigo;
		proforma_detalle.unidad = producto.unidad;
		proforma_detalle.producto_id = producto.id;
		proforma_detalle.graba_iva = producto.graba_iva;
		proforma_detalle.precio_unitario = parseFloat(producto.precio);
		proforma_detalle.subtotal = proforma_detalle.cantidad * proforma_detalle.precio_unitario;
		proforma_detalle.iva = proforma_detalle.subtotal * this.IVA;
		proforma_detalle.total = proforma_detalle.subtotal + proforma_detalle.iva;
		proforma_detalle.usuario_id = this.ss.getData('usuario_id');
		proforma_detalle.empresa_id = this.ss.getData('empresa_id');
		proforma_detalle.sucursal_id = this.ss.getData('sucursal_id');

		this.proformasDetalle.push(proforma_detalle);
		this.calcularFactura();
		//}
	}

	calcularFactura() {
		this.proforma.subtotal_iva12 = 0;
		this.proforma.subtotal_iva0 = 0;
		this.proforma.subt_desct_iva12 = 0;
		this.proforma.subt_desct_iva0 = 0;
		this.proforma.subt_desct_iva0 = 0;
		this.proforma.subt_desct_iva12 = 0;
		this.proforma.iva = 0;
		this.proforma.total = 0;    

		this.proformasDetalle.forEach(obj => {
			if(obj.graba_iva ){
				this.proforma.subtotal_iva12 += obj.subtotal;
			}else{
				this.proforma.subtotal_iva0 += obj.subtotal;
			}
		});
		let desc_porcent = (this.proforma.desct_porcent / 100);
		//desc_porcent = Math.round(desc_porcent * 100) / 100;
		desc_porcent = this.utils.redondear(desc_porcent,this.numero_decimales);
		this.proforma.desct_valor = (this.proforma.subtotal_iva0 + this.proforma.subtotal_iva12) * desc_porcent;
		this.proforma.subt_desct_iva0 = this.proforma.subtotal_iva0 - (desc_porcent * this.proforma.subtotal_iva0);
		this.proforma.subt_desct_iva12 = this.proforma.subtotal_iva12 - (desc_porcent * this.proforma.subtotal_iva12);
		//this.proforma.iva = Math.round((this.proforma.subt_desct_iva12 * this.IVA) * 100) / 100;
		this.proforma.iva = this.utils.redondear((this.proforma.subt_desct_iva12 * this.IVA),this.numero_decimales);
		this.proforma.total = this.proforma.subt_desct_iva12 + this.proforma.subt_desct_iva0 + this.proforma.iva;      
	
	}

  isValidForm(){
    
    if( !this.vl.validDate(this.fecha_emision.toString()) ){
        return false;
    }
    if( !this.vl.validDate(this.fecha_caducidad.toString()) ){
        return false;
    }
    if( !this.proforma.bodega_id ){
        return false;
    }
    if( !this.cliente.dni ){
        return false;
    }
    if( !this.proformasDetalle.length ){
        return false;
	}
	if(this.fecha_emision < this.fecha_MesAnt){
		return false;
	}
    return true;
  }

  onPrint(){
	let params = [];
	params["usuario_id"] = this.ss.getData('usuario_id');
	let qs = [];
	for(let key in params){
		let str = key + "=" + params[key];
		qs.push(str);
	}
    const initialState = {route: "proforma/" + this.proformaIdPrinted,  qs: "?" + qs.join("&")+ "&dbname="+this.ss.getData('dbname')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  }

  onSend(){  
    this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro del envio?").then(
      res => {
          this.loading = true;
          this.proformaService.correo(this.proformaIdPrinted).subscribe(
              res => {
                this.loading = false;
                this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente ');                 
              },
              err => {
                this.loading = false;
                this.msgSweet.showMessage('error-message',err);
              }
          );
        }
    );
  }

  changeValue(event, proforma_detalle: ProformaDetalle, campo: string){
    let dscto_valor = proforma_detalle.desc_valor;
    let dscto_porcent = proforma_detalle.desc_porcent;
    let value = event.target.value;

    proforma_detalle[campo] = value;

    if( campo === 'desc_porcent' ){
        if( proforma_detalle[campo] > 100 ){
            proforma_detalle[campo] = 100;
        }
    }

    let subtotal = (proforma_detalle.cantidad * proforma_detalle.precio_unitario) - proforma_detalle.desc_valor;
    let porcent_value = subtotal * (proforma_detalle.desc_porcent / 100)
    proforma_detalle.subtotal = subtotal - porcent_value;

    this.calcularFactura();
  }

  verificationValue(event, proforma_detalle: ProformaDetalle, campo: string){
    if( event.target.value.trim().length === 0 ){
        if( campo === 'cantidad' ){
            proforma_detalle[campo] = 1;
        }else{
            proforma_detalle[campo] = 0;
        }
    }
  }

	onDelete(i){
		this.proformasDetalle.splice(i,1);
		this.calcularFactura();
	}

	onChangeFecha(event){
        if(event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
        }
	}
	
	onSearchProforma(){
        const initialState = {numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(ProformaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProforma.take(1).subscribe((value) => {
			this.proformasDetalle = []
			this.loading = true;
			this.getProforma(value.id).then(
				res => this.loading = false,
				err => this.loading = false,
			);
		});
	}
	
	getProforma($id){
        let arrayPromise = [];
        return new Promise((resolve, reject)=>{
            this.proformaService.getById($id, "?embed=detalle,cliente?embed=tipoidentificacion").subscribe(
                res => {
						this.proforma = res.data;
						this.observacion = this.proforma.observacion;
						this.fecha_emision = moment(this.proforma.fecha_emision);
						this.fecha_caducidad = moment(this.proforma.fecha_caducidad);
						this.cliente = this.proforma.cliente;
						
                        this.proforma.detalle.forEach(item => {
                            let producto: any = {};

                            arrayPromise.push(new Promise((resolve, reject)=>{
                                this.productoService.getWithPrice(this.proforma.bodega_id, '?page=1&per_page=10&producto_id='+item.producto_id).subscribe(
                                    res => {
                                        if(res.data.length){
											let data1 = res.data[0];

											producto['cantidad_stock'] = data1.cantidad_stock;
											producto['cantidad'] = item.cantidad;
											// producto['es_servicio'] = data1.cantidad_stock;
											producto['tipo_producto_id'] = data1.tipo_producto_id;
											producto['descripcion'] = data1.descripcion;
											producto['nombre'] = data1.nombre;
											producto['codigo'] = data1.codigo;
											producto['unidad'] = data1.unidad;
											producto['id'] = data1.id;
											producto['graba_iva'] = data1.graba_iva;
											producto['precio'] = data1.precio;

                                            this.sendObjectProducto(producto)
                                        }
                                        else{
                                            this.msgSweet.showMessage('error-message', "El producto no tiene stock suficiente");
                                        }
                                        
                                        resolve();
                                    },
                                    err => {
                                        reject(err);
                                    }
                                );
                            }));
                        });

                        Promise.all(arrayPromise).then(
                            res=> resolve(),
                            err=>reject(err)
                        );                  
                },
                err => {
                    this.proforma = new Proforma;
                    reject(err);
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/proforma-add/proforma-add.component.ts